module.exports = __webpack_public_path__ + "img/404.d9366289.png";